export interface NavLink {
    label: string
    href: string
}

export const primaryNav: readonly NavLink[] = [
    { label: 'Work', href: '/work' },
    { label: 'About', href: '/about' },
    { label: 'Thoughts', href: '/thoughts' },
    { label: 'Contact', href: '/contact' }
]

export const overlayNav: readonly NavLink[] = [
    { label: 'Home', href: '/' },
    { label: 'Work', href: '/work' },
    { label: 'About', href: '/about' },
    { label: 'Thoughts', href: '/thoughts' },
    { label: 'Contact', href: '/contact' }
]

export const secondaryNav: readonly NavLink[] = [
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Terms Of Use', href: '/terms-of-use' }
]

export const footerNav: readonly NavLink[] = [
    { label: 'Home', href: '/' },
    { label: 'Work', href: '/work' },
    { label: 'About', href: '/about' },
    { label: 'Thoughts', href: '/thoughts' },
    { label: 'Contact', href: '/contact' },
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Terms Of Use', href: '/terms-of-use' }
]

export const socialLinks: readonly NavLink[] = [
    { label: 'Vimeo', href: 'https://vimeo.com' },
    { label: 'YouTube', href: 'https://youtube.com' },
    { label: 'Instagram', href: 'https://instagram.com' },
    { label: 'X (Twitter)', href: 'https://x.com' },
    { label: 'LinkedIn', href: 'https://linkedin.com' }
]
